import { Sun, Moon } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="flex items-center gap-3 w-full py-3 px-2 -mx-2 rounded-xl hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
      data-testid="theme-toggle-btn"
    >
      <div className="w-9 h-9 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center">
        {theme === "dark" ? (
          <Sun className="w-4 h-4 text-yellow-500" strokeWidth={2.2} />
        ) : (
          <Moon className="w-4 h-4 text-gray-700" strokeWidth={2.2} />
        )}
      </div>
      <span className="flex-1 text-left text-[14px] font-semibold dark:text-white">
        {theme === "dark" ? "Light Mode" : "Dark Mode"}
      </span>
      <div
        className={
          "w-10 h-5 rounded-full relative transition-colors bg-gray-200 dark:bg-emerald-500"
        }
      >
        <div
          className={
            "absolute top-1 left-1 w-3 h-3 rounded-full bg-white transition-transform " +
            (theme === "dark" ? "translate-x-5" : "")
          }
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
